import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-horizontal" }
const _hoisted_2 = { class: "table-responsive p-0" }
const _hoisted_3 = { class: "table table-bordered text-nowrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Level"),
    /*#__PURE__*/_createElementVNode("th", null, "Required experience"),
    /*#__PURE__*/_createElementVNode("th", null, "Credit reward"),
    /*#__PURE__*/_createElementVNode("th", null, "Heart reward"),
    /*#__PURE__*/_createElementVNode("th", null, "Booster type"),
    /*#__PURE__*/_createElementVNode("th", null, "Quantity")
  ])
], -1)
const _hoisted_5 = { class: "card-footer" }
const _hoisted_6 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_form_row = _resolveComponent("app-form-row")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Add Pet"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createVNode(_component_app_form_row, { label: "ID" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              type: "number",
              modelValue: _ctx.model.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.id) = $event)),
              modelModifiers: { number: true },
              validations: _ctx.v$.id
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Interactive Seconds" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              type: "number",
              modelValue: _ctx.model.interactiveSeconds,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.interactiveSeconds) = $event)),
              modelModifiers: { number: true },
              validations: _ctx.v$.interactiveSeconds
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Total Level" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              type: "number",
              modelValue: _ctx.model.totalLevel,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.totalLevel) = $event)),
              modelModifiers: { number: true },
              validations: _ctx.v$.totalLevel
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Gacha Weights" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              modelValue: _ctx.model.gachaWeights,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.gachaWeights) = $event)),
              validations: _ctx.v$.gachaWeights,
              placeholder: "Level0:Weight0,Level1:Weight1...LevelMax:0 Ex: 0:120,1:100,2:70,3:0"
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.rewardList, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "data-row",
                  key: index
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_app_input, {
                      type: "number",
                      modelValue: item.level,
                      "onUpdate:modelValue": ($event: any) => ((item.level) = $event),
                      modelModifiers: { number: true },
                      disabled: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_app_input, {
                      type: "number",
                      modelValue: item.requiredExperience,
                      "onUpdate:modelValue": ($event: any) => ((item.requiredExperience) = $event),
                      modelModifiers: { number: true },
                      disabled: _ctx.model.totalLevel == item.level,
                      validations: _ctx.rewardV$(index, 'requiredExperience').value
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "validations"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_app_input, {
                      type: "number",
                      modelValue: item.creditReward,
                      "onUpdate:modelValue": ($event: any) => ((item.creditReward) = $event),
                      modelModifiers: { number: true },
                      validations: _ctx.rewardV$(index, 'creditReward').value
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "validations"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_app_input, {
                      type: "number",
                      modelValue: item.heartReward,
                      "onUpdate:modelValue": ($event: any) => ((item.heartReward) = $event),
                      modelModifiers: { number: true },
                      validations: _ctx.rewardV$(index, 'heartReward').value
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "validations"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_app_select, {
                      options: _ctx.SelectableBooster,
                      modelValue: item.boosterTypeReward,
                      "onUpdate:modelValue": ($event: any) => ((item.boosterTypeReward) = $event),
                      modelModifiers: { number: true },
                      validations: _ctx.rewardV$(index, 'boosterTypeReward').value,
                      style: {"min-width":"170px"}
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "validations"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_app_input, {
                      type: "number",
                      modelValue: item.boosterQuantityReward,
                      "onUpdate:modelValue": ($event: any) => ((item.boosterQuantityReward) = $event),
                      modelModifiers: { number: true },
                      validations: _ctx.rewardV$(index, 'boosterQuantityReward').value
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "validations"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_app_button, {
              name: "Create",
              theme: "info",
              icon: "fa-save",
              onClick: _withModifiers(_ctx.actions.create, ["prevent"])
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}